<template>
  <div class="border bg-white">
    <div class="p-4">
      <template v-if="loading">
        <div class="text-muted">Loading...</div>
      </template>
      <template v-else>
        <b-row>
          <b-col cols="12" md="6" class="mb-2">
            <b-row>
              <b-col cols="5" class="text-muted font-weight-bold">Profile</b-col>
              <b-col cols="7" class="text-secondary font-weight-bold text-break">
                <strong>{{ profileName }}</strong>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <b-row>
              <b-col cols="5" class="text-muted font-weight-bold">Status profile</b-col>
              <b-col cols="7" class="text-secondary font-weight-bold text-break">
                <strong>{{ profileStatus }}</strong>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <b-row>
              <b-col cols="5" class="text-muted font-weight-bold">Teknisi</b-col>
              <b-col cols="7" class="text-secondary font-weight-bold text-break">
                <strong>{{ technician }}</strong>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="mb-2">
            <b-row>
              <b-col cols="5" class="text-muted font-weight-bold">Dicek pada</b-col>
              <b-col cols="7" class="text-secondary font-weight-bold text-break">
                <strong>{{ checkedAt }}</strong>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-img
          v-if="photoSource"
          :src="photoSource"
          :alt="photoAlt"
          fluid
          thumbnail
          class="mb-3"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import * as customProfileApi from '@/services/rest-api-sms/lib/custom-profile/custom-profile'

export default {
  name: 'ChecklistDetailCustomProfile',
  mixins: [Helper],
  props: {
    taskData: {
      type: Object,
      default: () => ({}),
    },
    workOrder: {
      type: Object,
      default: () => ({}),
    },
    checklist: {
      type: Object,
      default: () => ({}),
    },
    checklistDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      profile: null,
    }
  },
  computed: {
    vehicle() {
      return (
        this.taskData?.vehicle
      )
    },
    customProfileId() {
      return (
        this.taskData?.vehicle?.custom_profile_id
      )
    },
    profileName() {
      return this.profile?.name
    },
    profileStatus() {
      const status = 'Enable'

      if (status === false) return 'Disable'
      if (String(status || '').toLowerCase().includes('disable')) return 'Disable'
      if (String(status || '').toLowerCase() === 'false') return 'Disable'
      return this.customProfileId ? 'Enable' : '-'
    },
    technician() {
      return this.workOrder?.teknisi 
    },
    checkedAt() {
      const checkedAt =
        this.checklist?.created_at

      return checkedAt ? this.momentDMHms(checkedAt) : '-'
    },
    photoSource() {
      return this.checklistDetail?.url || this.checklistDetail?.photo_url || this.checklistDetail?.photo
    },
    photoAlt() {
      return this.checklistDetail?.photo || 'Custom Parameter'
    },
  },
  created() {
    this.fetchCustomProfile()
  },
  watch: {
    customProfileId() {
      this.fetchCustomProfile()
    },
  },
  methods: {
    async fetchCustomProfile() {
      if (!this.customProfileId) {
        this.profile = null
        return
      }

      this.loading = true

      try {
        const response = await customProfileApi.get({
          filters: [`custom_profile_id eq ${this.customProfileId}`],
          limit: 1,
        })

        this.profile =
          response?.data?.paginated_result?.[0] ||
          response?.data?.[0] ||
          response?.data ||
          null
      } catch (error) {
        this.profile = null
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
